import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperAdminAuth } from '../../auth/SuperAdminAuthContext.jsx';
import { AuthLayout } from '../../components/layout/AuthLayout.jsx';
import { PasswordField } from '../../components/forms/PasswordField.jsx';
import { Icon } from '../../components/Icon.jsx';

export function LoginPage() {
  const { login } = useSuperAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/super-admin/tenants', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Welcome back." description="Sign in to manage your restaurants and their teams." role="Super admin" footer="Access for platform administrators.">
      {error && <div className="alert alert-error" role="alert">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <PasswordField id="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />

        <button type="submit" className="btn btn-primary auth-submit" disabled={submitting}>
          {submitting ? <><span className="spinner" /> Signing in…</> : <>Sign in <Icon name="arrow" size={17} /></>}
        </button>
      </form>
    </AuthLayout>
  );
}
